import { render, staticRenderFns } from "./fundingAgency.vue?vue&type=template&id=39ed2426&scoped=true"
import script from "./fundingAgency.vue?vue&type=script&lang=js"
export * from "./fundingAgency.vue?vue&type=script&lang=js"
import style0 from "./fundingAgency.vue?vue&type=style&index=0&id=39ed2426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed2426",
  null
  
)

export default component.exports